//import  router from '../router/index.js';
export default {
    handleResponse: async (response) => {
        let a = await response.json();
        return response.status === 200 ? { isOk: true, data: a } : { isOk: false, data: 'Có lỗi xảy ra - vui lòng thử lại' };
    },
    
    validateEmail: (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    },
    
    validatePhoneNumber: (phoneNumber) => {
        const regex = /^\d{10}$/;
        return regex.test(phoneNumber);
    },
    
    validatePassword: (password) => {
        const regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
        return regex.test(password);
    },

    formatDateTime: (date) => {
        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
    },
};